export enum VoteType {
    Veto = "veto",
    Objection = "objection",
    Skip = "skip"
}